<template>
  <audio :id="id" class="w-100" controls :autoplay="autoplay">
    <source :src="src" type="audio/mp3" />
    Your browser does not support the audio element.
  </audio>
</template>

<script>
export default {
  name: 'AudioPlay',
  props: {
    src: {
      require: true,
      type: String,
    },
    autoplay: Boolean,
    id: String,
    onPlay: Function,
  },
  date() {
    return {
      audio: null,
    };
  },
  mounted() {
    this.audio = document.getElementById(this.id);
    this.audio.addEventListener('play', this.handleOnPlayEvent);
  },
  methods: {
    handleOnPlayEvent() {
      // eslint-disable-next-line no-unused-expressions
      this.onPlay && this.onPlay(this.audio);
    },
  },
  beforeDestroy() {
    this.audio.removeEventListener('play', this.handleOnPlayEvent);
  },
};
</script>
